import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { SilentLoginComponent } from "./silent-login.component";

const routes: Routes = [
    {
        path: "unr/:ejendomnr/inr/:installationnr/anr/:aktivnr/id/:cryptid/origin/:origin",
        component: SilentLoginComponent
    },
    {
        path: "unr/:ejendomnr/inr/:installationnr/anr/:aktivnr/id/:cryptid",
        component: SilentLoginComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SilentLoginRoutingModule {}
